export enum FgStockStates {
    AllocatedForRepacking = 'Allocated For Repacking',
    AllocatedForReprocessing = 'Allocated For Reprocessing',
    AssignedForRepacking = 'Assigned For Repacking',
    PartiallyAssignedForRepacking = 'Partially Assigned For Repacking',
    PartiallyAssignedForReprocessing = 'Partially Assigned For Reprocessing',
    AssignedForReprocessing = 'Assigned For Reprocessing',
    Stock = 'Stock',
    AllocatedForRework = 'Allocated For Rework',
    PartiallyAssignedForRework = 'Partially Assigned For Rework',
    AssignedForRework = 'Assigned For Rework',
}